module.exports = __webpack_public_path__ + "assets/img/ko-2e8f3346.png";